// extracted by mini-css-extract-plugin
module.exports = {"productRibbon":"jMeVp"};